// ImageListViewer.js
import React, { useState } from "react";
import { Dialog, DialogContent, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

import moment from "moment";

const ImageListViewer = ({ data, open, onClose }) => {
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  const handlePrevImage = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex > 0 ? prevIndex - 1 : data.length - 1
    );
  };

  const handleNextImage = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex < data.length - 1 ? prevIndex + 1 : 0
    );
  };

  const currentImageData = data[selectedImageIndex];

  return (
    <Dialog open={open} onClose={onClose} fullScreen>
      <DialogContent style={{ backgroundColor: "black", overflow: "hidden" }}>
        <IconButton
          aria-label="close"
          size="large"
          color="white"
          style={{ position: "absolute", right: 10, top: 10, fontSize: 30 }}
          onClick={onClose}
        >
          <CloseIcon fontSize="inherit" />
        </IconButton>

        <div
          style={{
            //position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            overflow: "hidden",
          }}
        >
          <img
            src={currentImageData.url}
            alt={`Selected Image`}
            style={{ maxHeight: "99%", maxWidth: "95%", margin: 10 }}
          />
          <div
            style={{
              position: "absolute",
              bottom: 20,
              left: 0,
              right: 0,
              background: "rgba(0, 0, 0, 0.5)",
              padding: "10px",
              textAlign: "center",
            }}
          >
            <Typography variant="h6" style={{ color: "white" }}>
              {currentImageData.title}
            </Typography>
            <Typography variant="body2" style={{ color: "white" }}>
              {"by " +
                currentImageData.author +
                " on " +
                moment(currentImageData.timestamp).format("DD/MM/YYYY HH:mm")}
            </Typography>
          </div>
        </div>
        {data.length > 1 && (
          <>
            <IconButton
              color="white"
              size="large"
              onClick={handlePrevImage}
              style={{
                position: "absolute",
                left: 5,
                top: "50%",
                transform: "translateY(-50%)",
                fontSize: 40,
              }}
            >
              <KeyboardArrowLeftIcon fontSize="inherit" />
            </IconButton>
            <IconButton
              color="white"
              size="large"
              onClick={handleNextImage}
              style={{
                position: "absolute",
                right: 5,
                top: "50%",
                transform: "translateY(-50%)",
                fontSize: 40,
              }}
            >
              <KeyboardArrowRightIcon fontSize="inherit" />
            </IconButton>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ImageListViewer;
